/**
 * Print Career chapter — Canva page-07 template plus "This month's pulse".
 * Own A4 sheet. Uses hero-career.jpg (user-supplied professional-growth
 * staircase JPEG; wired via PdfAspectDeepDive aspectHeroSrc).
 */

import React from "react";
import type { MonthlyConsultationBundle } from "../../../../utils/forecast/monthlyConsultation";
import { PdfAspectDeepDive } from "./PdfAspectDeepDive";

/**
 * Props for the PDF career chapter.
 */
export interface PdfChapterCareerProps {
  /** Full monthly consultation payload. */
  bundle: MonthlyConsultationBundle;
  /** 1-based sequential page index among rendered sheets. */
  pageNumber?: number;
}

/**
 * Resolve Career scorecard row from the bundle.
 *
 * @param bundle - Monthly consultation payload
 * @returns Matching scorecard dimension or null
 */
function careerScore(bundle: MonthlyConsultationBundle) {
  const rows = Array.isArray(bundle.scorecard) ? bundle.scorecard : [];
  const match = rows.find((row) => {
    const label = typeof row.label === "string" ? row.label.trim().toLowerCase() : "";
    return label === "career" || label.includes("career") || label.includes("work");
  });
  return match ?? null;
}

/**
 * Career life-area deep dive — always starts on its own page.
 */
export const PdfChapterCareer: React.FC<PdfChapterCareerProps> = ({
  bundle,
  pageNumber,
}) => (
  <PdfAspectDeepDive
    chapterId="career"
    title="Career"
    eyebrow="Life areas"
    playbook={bundle.aspectPlaybooks.career}
    snapshot={bundle.aspectPalaces.career}
    scorecard={careerScore(bundle)}
    breakBefore="always"
    pageNumber={pageNumber}
  />
);

export default PdfChapterCareer;
